export default __webpack_public_path__ + "static/media/main.a5574efb.mp3";